/** Filter controls aligned with vendor portal cards (prodotti, profilo). */
export const catalogFilterSearchInputSx = {
  borderRadius: "12px",
  backgroundColor: "#ffffff",
  height: "48px",
  fontSize: "0.9rem",
  fontFamily: "Rubik, sans-serif",
  "&:hover fieldset": { borderColor: "#cbd5e1 !important" },
  "&.Mui-focused fieldset": {
    borderColor: "#0b3d87 !important",
    borderWidth: "1px",
  },
  "& fieldset": { borderColor: "#e2e8f0 !important" },
};

export const catalogFilterSelectSx = {
  borderRadius: "12px",
  backgroundColor: "#ffffff",
  height: "48px",
  fontSize: "0.85rem",
  fontFamily: "Rubik, sans-serif",
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#cbd5e1 !important" },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#0b3d87 !important",
    borderWidth: "1px",
  },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0 !important" },
};

export const catalogFilterLabelSx = {
  fontFamily: "Rubik, sans-serif",
  color: "#64748b",
  fontSize: "0.75rem",
  fontWeight: 600,
  mb: 0.5,
};

export const catalogFilterSliderSx = {
  color: "#0b3d87",
  py: 0.5,
  "& .MuiSlider-thumb": {
    width: 16,
    height: 16,
    transition: "none",
    "&:hover, &.Mui-focusVisible, &.Mui-active": {
      boxShadow: "none",
    },
  },
  "& .MuiSlider-track": {
    height: 4,
    border: "none",
  },
  "& .MuiSlider-rail": {
    height: 4,
    opacity: 1,
    backgroundColor: "rgba(11, 61, 135, 0.15)",
  },
};

export const catalogSuggestPaperSx = {
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  mt: 0.5,
  zIndex: 20,
  maxHeight: 280,
  overflowY: "auto",
  borderRadius: "12px",
  border: "1px solid rgba(0, 0, 0, 0.08)",
  boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)",
};
